export const columns = [
  {
    title: '序号',
    customRender: (text, record, index) => index + 1,
  },
  {
    title: '模板名称',
    dataIndex: 'name',
  },
  {
    title: '调研目的',
    dataIndex: 'aim',
  },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index)=>{
      return record.status===0?'禁用':'启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
